import React from 'react';
import './SlideInContent.css';

class SlideInContent extends React.Component {
    
    constructor(props) {
        super(props);

        const defaultVisible = !!props.defaultVisible;

        this.state = {
            isVisible: defaultVisible,
            shouldRender: defaultVisible,
        };

        this.hideTimeout = null;
        this.nextFrame = null;
        const hasWindow = typeof window !== 'undefined';
        this.raf = hasWindow && typeof window.requestAnimationFrame === 'function'
            ? window.requestAnimationFrame.bind(window)
            : (callback) => setTimeout(callback, 16);
        this.caf = hasWindow && typeof window.cancelAnimationFrame === 'function'
            ? window.cancelAnimationFrame.bind(window)
            : clearTimeout;
    }

    componentWillUnmount() {
        this.clearTimers();
    }

    clearTimers = () => {
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
            this.hideTimeout = null;
        }

        if (this.nextFrame) {
            this.caf(this.nextFrame);
            this.nextFrame = null;
        }
    };

    setVisible = (set_to) => {
        const targetVisible = !!set_to;
        const animationDuration = typeof this.props.animationDuration === 'number' ? this.props.animationDuration : 400;

        this.clearTimers();

        if (targetVisible) {
            if (!this.state.shouldRender) {
                this.setState({ shouldRender: true }, () => {
                    this.nextFrame = this.raf(() => {
                        this.nextFrame = null;
                        this.setState({ isVisible: true });
                    });
                });
            } else {
                this.setState({ isVisible: true });
            }
        } else {
            this.setState({ isVisible: false }, () => {
                this.hideTimeout = setTimeout(() => {
                    this.hideTimeout = null;
                    this.setState({ shouldRender: false }, () => {
                        if (typeof this.props.onHidden === 'function') {
                            this.props.onHidden();
                        }
                    });
                }, animationDuration);
            });
        }
    }

    render() {
        const { className, children } = this.props;
        const { isVisible, shouldRender } = this.state;

        if (!shouldRender) {
            return null;
        }

        const combinedClassName = [
            'slide-in-content',
            className,
            isVisible ? 'visible' : ''
        ].join(' ').trim();

        return (
            <div className={combinedClassName}>
                {children}
            </div>
        );
    }
}

export default SlideInContent;